import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: theme.spacing(4),
  },
  card: {
    maxWidth: 600,
    width: '100%',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  message: {
    fontSize: '1.2rem',
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

function Unauthorized(props) {
  const classes = useStyles();
  const message = props.message
  //const history = useHistory();

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardBody>
          <div className={classes.title}> {message.header ? message.header : "Contact with your administrator" } </div>
          <div 
            className={classes.message}
            dangerouslySetInnerHTML={{
              __html: message.body || "You are not authorized to access this prospect as it's already assigned to another user."
            }}
          />
          {/* <Button
            color="primary"
            onClick={() => history.push('/dashboard')}
            className={classes.button}
          >
            Go to Dashboard
          </Button> */}
        </CardBody>
      </Card>
    </div>
  );
}

export default Unauthorized;
